import { Box, IconNew, ImageNew, SpacerNew, TextNew } from '@jfs/ui-new'
import { memo, FC } from 'react'
import { HEIGHT_QR_CODE, WIDTH_QR_CODE } from '../../../data/request/getQrCodeRequest'
import { styles } from './styles'

interface QRCodeInterfce {
  qrImage: string
}

const QRCode: FC<QRCodeInterfce> = memo(({ qrImage }: QRCodeInterfce) => {
  return (
    <Box {...styles.whiteQrCodeView}>
      <Box {...styles.qrCodeContainer}>
        <ImageNew source={qrImage} height={HEIGHT_QR_CODE} width={WIDTH_QR_CODE} resizeMode="cover" />
      </Box>
      <SpacerNew size={10} />
      <Box {...styles.myJioView}>
        <Box {...styles.scanBg}>
          <TextNew {...styles.scanText} title={'Scan to pay with'?.toUpperCase()} />
        </Box>
        <IconNew id="JIO_ICON" color="ERROR" size={24} />
        <SpacerNew size={8} direction="horizontal" />
        <TextNew {...styles.myJioText} title={'MyJio'} />
      </Box>
    </Box>
  )
})

export { QRCode }
